import CustomerAddress from "./modals/customer-address";

export default CustomerAddress;